import React from 'react';
import { TextField, TextFieldProps } from '@mui/material';
import { Controller } from 'react-hook-form';

type FormTextFieldProps = TextFieldProps & {
  name: string;
  control: any;
  rules?: any;
  type?: string;
};

const FormTextField: React.FC<FormTextFieldProps> = ({
  name,
  control,
  type,
  rules = {},
  ...props
}) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          {...props}
          type={type}
          fullWidth
          error={!!error}
          helperText={error?.message}
        />
      )}
    />
  );
};

export default FormTextField;

export const RequiredLabel = ({ label }: { label: string }) => (
  <>
    {label}
    <span style={{ color: '#d32f2f', marginLeft: 2 }}>*</span>
  </>
);
